function ngT(en, tr, da) {
  var lang = (document.documentElement.lang || 'da').toLowerCase().split('-')[0];
  if (lang === 'en') return en;
  if (lang === 'tr') return tr;
  return da;
}
function ngLocaleRoot() {
  var lang = (document.documentElement.lang || "da").toLowerCase().split("-")[0];
  if (lang === "da") return "/da-dk/";
  return "/" + lang + "/";
}
/* =============================================
   NORDELE GASTRO — Product Detail Page JS
   Image gallery, quantity, tabs, variant selection
   ============================================= */

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initImageGallery();
    initQuantitySelector();
    initTabs();
    initVariantSelection();
    initQuickBuy();
  });

  /* ─── Image Gallery ─── */
  function initImageGallery() {
    var thumbs = document.querySelectorAll(".ng-pdp__thumb");
    var mainImage = document.getElementById("ngPdpMainImage");
    var mainWrap = document.getElementById("ngPdpMainImageWrap");
    var isZoomed = false;

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        // Remove active from all thumbs
        thumbs.forEach(function (t) {
          t.classList.remove("ng-pdp__thumb--active");
        });
        // Add active to clicked
        this.classList.add("ng-pdp__thumb--active");
        // Switch main image
        var fullSrc = this.getAttribute("data-full-src");
        if (fullSrc) {
          mainImage.style.opacity = "0";
          setTimeout(function () {
            mainImage.src = fullSrc;
            mainImage.style.opacity = "1";
          }, 150);
        }
        // Reset zoom
        isZoomed = false;
        mainImage.classList.remove("ng-pdp__main-image--zoomed");
      });
    });

    // Click to zoom on main image
    if (mainWrap) {
      mainWrap.addEventListener("click", function (e) {
        // Ignore clicks on action buttons
        if (e.target.closest(".ng-pdp__image-actions")) return;

        isZoomed = !isZoomed;
        if (isZoomed) {
          mainImage.classList.add("ng-pdp__main-image--zoomed");
          mainWrap.style.cursor = "zoom-out";
        } else {
          mainImage.classList.remove("ng-pdp__main-image--zoomed");
          mainWrap.style.cursor = "zoom-in";
        }
      });
    }
  }

  /* ─── Quantity +/- ─── */
  function initQuantitySelector() {
    var qtyBtns = document.querySelectorAll(".ng-pdp__qty-btn");
    var qtyInput = document.getElementById("ngQuantityInput");

    if (!qtyInput || qtyBtns.length === 0) return;

    qtyBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var action = this.getAttribute("data-action");
        var currentVal = parseInt(qtyInput.value, 10) || 1;

        if (action === "decrease") {
          qtyInput.value = Math.max(1, currentVal - 1);
        } else if (action === "increase") {
          qtyInput.value = currentVal + 1;
        }

        // Update quick buy price
        updateQuickBuyPrice();
      });
    });

    qtyInput.addEventListener("change", function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) {
        this.value = 1;
      }
      updateQuickBuyPrice();
    });
  }

  /* ─── Tab Switching ─── */
  function initTabs() {
    var tabBtns = document.querySelectorAll(".ng-pdp-tabs__btn");
    var tabPanels = document.querySelectorAll(".ng-pdp-tab");

    if (tabBtns.length === 0) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var tabKey = this.getAttribute("data-tab");

        // Toggle active button
        tabBtns.forEach(function (b) {
          b.classList.remove("ng-pdp-tabs__btn--active");
        });
        this.classList.add("ng-pdp-tabs__btn--active");

        // Toggle active panel
        tabPanels.forEach(function (panel) {
          if (panel.getAttribute("data-tab-content") === tabKey) {
            panel.classList.add("ng-pdp-tab--active");
          } else {
            panel.classList.remove("ng-pdp-tab--active");
          }
        });
      });
    });
  }

  /* ─── Variant Selection ─── */
  function initVariantSelection() {
    var variantBtns = document.querySelectorAll(".ng-pdp__variant-btn");
    var variantInput = document.getElementById("ngVariantInput");
    var priceEl = document.querySelector(".ng-pdp__price");
    var comparePriceEl = document.querySelector(".ng-pdp__compare-price");
    var skuEl = document.querySelector(".ng-pdp__sku");
    var addToCartBtn = document.querySelector(".ng-pdp__add-to-cart");
    var mainImage = document.getElementById("ngPdpMainImage");

    if (variantBtns.length === 0) return;

    variantBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var variantId = this.getAttribute("data-variant-id");
        var variantPrice = this.getAttribute("data-variant-price");
        var variantComparePrice = this.getAttribute("data-variant-compare-price");
        var variantSku = this.getAttribute("data-variant-sku");
        var variantAvailable = this.getAttribute("data-variant-available") === "true";
        var variantImage = this.getAttribute("data-variant-image");

        // Toggle active state
        variantBtns.forEach(function (b) {
          b.classList.remove("ng-pdp__variant-btn--active");
        });
        this.classList.add("ng-pdp__variant-btn--active");

        // Update hidden input
        if (variantInput) {
          variantInput.value = variantId;
        }

        // Update price display
        if (priceEl && variantPrice) {
          priceEl.textContent = variantPrice;
        }

        // Update compare price
        if (comparePriceEl && variantComparePrice) {
          comparePriceEl.textContent = variantComparePrice;
        }

        // Update SKU
        if (skuEl && variantSku) {
          skuEl.textContent = "SKU: " + variantSku;
        }

        // Update add to cart button
        if (addToCartBtn) {
          if (variantAvailable) {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML =
              'L\u00e6g i kurv <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.innerHTML = ngT("Sold out", "Tükendi", "Udsolgt");
          }
        }

        // Switch featured image if variant has one
        if (variantImage && mainImage) {
          mainImage.style.opacity = "0";
          setTimeout(function () {
            mainImage.src = variantImage;
            mainImage.style.opacity = "1";
          }, 150);
        }

        // Update URL without reload
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variantId);
          window.history.replaceState({}, "", url.toString());
        }

        // Update quick buy price
        updateQuickBuyPrice();
      });
    });
  }

  /* ─── Quick Buy ─── */
  function initQuickBuy() {
    var quickBuyBtn = document.getElementById("ngQuickBuy");
    if (!quickBuyBtn) return;

    quickBuyBtn.addEventListener("click", function () {
      var form = document.getElementById("ngProductForm");
      if (!form) return;

      var btnText = quickBuyBtn.textContent;
      quickBuyBtn.disabled = true;
      quickBuyBtn.textContent = "Behandler...";

      var formData = new FormData(form);
      fetch(ngLocaleRoot() + 'cart/add.js', {
        method: "POST",
        body: formData,
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Kunne ikke tilføje til kurv");
          return response.json();
        })
        .then(function () {
          window.location.href = ngLocaleRoot().replace(/\/$/, "") + "/checkout";
        })
        .catch(function (err) {
          console.error("Quick buy error:", err);
          quickBuyBtn.disabled = false;
          quickBuyBtn.textContent = btnText;
          // Show user-visible error
          var errorEl = document.createElement("p");
          errorEl.className = "ng-pdp__quick-buy-error";
          errorEl.textContent = "Der opstod en fejl. Prøv igen.";
          errorEl.style.cssText = "color:#E5243F;font-size:13px;margin-top:8px;text-align:center;";
          var existing = form.parentElement.querySelector(".ng-pdp__quick-buy-error");
          if (existing) existing.remove();
          quickBuyBtn.parentElement.appendChild(errorEl);
          setTimeout(function () { errorEl.remove(); }, 5000);
        });
    });
  }

  /* ─── Helper: Update Quick Buy Price ─── */
  function updateQuickBuyPrice() {
    var quickBuyPrice = document.getElementById("ngQuickBuyPrice");
    var activeVariant = document.querySelector(
      ".ng-pdp__variant-btn--active"
    );
    var qtyInput = document.getElementById("ngQuantityInput");

    if (!quickBuyPrice) return;

    var priceText = "";
    if (activeVariant) {
      priceText = activeVariant.getAttribute("data-variant-price") || "";
    } else {
      var priceEl = document.querySelector(".ng-pdp__price");
      if (priceEl) priceText = priceEl.textContent || "";
    }

    // Parse the price to a number (handle Danish format: 65.340 kr)
    var priceNum = parseFloat(
      priceText.replace(/[^\d,.-]/g, "").replace(".", "").replace(",", ".")
    );
    var qty = parseInt(qtyInput ? qtyInput.value : "1", 10) || 1;

    if (!isNaN(priceNum)) {
      var total = priceNum * qty;
      // Format as Danish number
      var formatted = total
        .toLocaleString("da-DK", { minimumFractionDigits: 0 })
        .replace(/\./g, ".");
      quickBuyPrice.textContent = formatted + " kr.";
    }
  }
})();
